import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import {
  getRating,
  getReviews,
  getShortLink,
} from 'src/store/appBanners/selectors';
import {
  getDeeplinkAction,
  goToMobileAppAction,
  moveToAppContinuedWeb,
  moveToAppShown,
} from 'src/store/appBanners/slice';
import { DesktopAppBanner } from './DesktopAppBanner';

const mapStateToProps = (state) => ({
  appLink: getShortLink(state),
  reviewsCountText: getReviews(state),
  rating: Number(getRating(state).replace(',', '.')),
});

const mapDispatchToProps = {
  onShow: moveToAppShown,
  getDeeplink: getDeeplinkAction,
  moveToAppContinuedWeb,
  getStoreData: goToMobileAppAction,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DesktopAppBanner);
